import React, { useMemo, useState } from 'react'

import AdminLayout from '../components/AdminLayout'

import './manpower.css'

type StaffRow = {
  name: string
  role: string
  site: string
  shift: string
  contact: string
  status: 'On duty' | 'Off duty' | 'Leave'
}

const STAFF: StaffRow[] = [
  {
    name: 'Amit Verma',
    role: 'Plant Supervisor',
    site: 'Jagjeetpur STP',
    shift: 'General',
    contact: '+91 98xxx xxxxx',
    status: 'On duty',
  },
  {
    name: 'Sunita Joshi',
    role: 'Lab Analyst',
    site: 'Jagjeetpur STP',
    shift: 'Night',
    contact: '+91 97xxx xxxxx',
    status: 'On duty',
  },
  {
    name: 'Ravi Khanna',
    role: 'Electrician',
    site: 'Rishikesh STP',
    shift: 'Day',
    contact: '+91 96xxx xxxxx',
    status: 'Leave',
  },
  {
    name: 'Meera Iyer',
    role: 'O&M Lead',
    site: 'Varanasi Zone',
    shift: 'General',
    contact: '+91 88xxx xxxxx',
    status: 'Off duty',
  },
]

const Manpower = () => {
  const [q, setQ] = useState('')
  const [site, setSite] = useState('')

  const rows = useMemo(() => {
    const needle = q.trim().toLowerCase()
    return STAFF.filter((r) => {
      if (site && r.site !== site) return false
      if (!needle) return true
      const blob = `${r.name} ${r.role} ${r.site}`.toLowerCase()
      return blob.includes(needle)
    })
  }, [q, site])

  const onDuty = STAFF.filter((r) => r.status === 'On duty').length
  const onLeave = STAFF.filter((r) => r.status === 'Leave').length

  return (
    <AdminLayout title="Manpower" activeNav="manpower" pageTitle="Manpower - Namami Gange">
      <div className="manpower-toolbar">
        <div className="manpower-toolbar-left">
          <label className="visually-hidden" htmlFor="manpower-search">
            Search workforce
          </label>
          <input
            id="manpower-search"
            type="search"
            className="manpower-search"
            placeholder="Search by name or role…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
          />
          <label className="visually-hidden" htmlFor="manpower-site-filter">
            Site filter
          </label>
          <select
            id="manpower-site-filter"
            className="manpower-filter"
            value={site}
            onChange={(e) => setSite(e.target.value)}
          >
            <option value="">All sites</option>
            <option value="Jagjeetpur STP">Jagjeetpur STP</option>
            <option value="Rishikesh STP">Rishikesh STP</option>
            <option value="Varanasi Zone">Varanasi Zone</option>
          </select>
        </div>
        <button type="button" className="manpower-primary">
          Add staff
        </button>
      </div>

      <div className="admin-card-grid">
        <div className="admin-stat-card">
          <h3>Workforce registered</h3>
          <div className="admin-stat-value">186</div>
          <div className="admin-stat-sub">Across active contracts</div>
        </div>
        <div className="admin-stat-card">
          <h3>On duty today</h3>
          <div className="admin-stat-value manpower-stat-ok">{onDuty}</div>
          <div className="admin-stat-sub">Field + control room</div>
        </div>
        <div className="admin-stat-card">
          <h3>On leave</h3>
          <div className="admin-stat-value manpower-stat-muted">{onLeave}</div>
          <div className="admin-stat-sub">Approved this week</div>
        </div>
        <div className="admin-stat-card">
          <h3>Open positions</h3>
          <div className="admin-stat-value">7</div>
          <div className="admin-stat-sub">O&M + technical</div>
        </div>
      </div>

      <div className="manpower-mid">
        <div className="admin-panel">
          <h2>Staff directory</h2>
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Role</th>
                  <th>Site</th>
                  <th>Shift</th>
                  <th>Contact</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={`${r.name}-${r.site}`}>
                    <td>{r.name}</td>
                    <td>{r.role}</td>
                    <td>{r.site}</td>
                    <td>{r.shift}</td>
                    <td>{r.contact}</td>
                    <td>
                      {r.status === 'On duty' && <span className="admin-pill">On duty</span>}
                      {r.status === 'Leave' && (
                        <span className="admin-pill admin-pill--muted">On leave</span>
                      )}
                      {r.status === 'Off duty' && (
                        <span className="admin-pill admin-pill--neutral">Off duty</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="admin-panel">
          <h2>Today’s roster highlights</h2>
          <ul className="manpower-roster-list">
            <li className="manpower-roster-item">
              <div>
                <strong>Morning briefing</strong>
                <span>Jagjeetpur · 09:00</span>
              </div>
              <div className="manpower-roster-meta">Scheduled</div>
            </li>
            <li className="manpower-roster-item">
              <div>
                <strong>Lab sampling round</strong>
                <span>Shift B · Outlet channel</span>
              </div>
              <div className="manpower-roster-meta">In progress</div>
            </li>
            <li className="manpower-roster-item">
              <div>
                <strong>Electrical preventive check</strong>
                <span>Rishikesh STP · Ravi Khanna replaced</span>
              </div>
              <div className="manpower-roster-meta">Backup assigned</div>
            </li>
          </ul>
        </div>
      </div>

      <div className="admin-panel">
        <h2>Training & certifications</h2>
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Course</th>
                <th>Due renewals</th>
                <th>Completed (90d)</th>
                <th>Owner</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Workplace safety refresher</td>
                <td>12</td>
                <td>34</td>
                <td>HR · Namami Gange</td>
              </tr>
              <tr>
                <td>Hazardous chemical handling</td>
                <td>5</td>
                <td>18</td>
                <td>Plant SHE</td>
              </tr>
              <tr>
                <td>SCADA fundamentals</td>
                <td>3</td>
                <td>9</td>
                <td>IT–OT coordination</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  )
}

export default Manpower
